import { Check } from 'lucide-react'

type State = 'complete' | 'inProgress' | 'toDo'

const nodeClass: Record<State, string> = {
  complete: 'border-accent bg-accent text-accent-foreground',
  inProgress: 'border-accent text-accent ring-4 ring-accent/15',
  toDo: 'border-border text-muted-foreground',
}

/**
 * A row of numbered milestone nodes connected by edges. Each node is toDo,
 * inProgress (the current step), or complete (a filled check with a filled
 * trailing edge). `current` is the 0-based index of the active step. Flex
 * direction follows the document `dir`, so it flips correctly in RTL.
 */
export const MilestoneProgress = ({ count, current }: { count: number; current: number }) => {
  const states: State[] = Array.from({ length: count }, (_, i) =>
    i < current ? 'complete' : i === current ? 'inProgress' : 'toDo',
  )
  return (
    <ol className="flex items-center justify-center" aria-label="progress">
      {states.map((state, i) => (
        <li key={i} className="flex items-center">
          <span
            className={`grid h-9 w-9 place-items-center rounded-full border-2 text-sm font-semibold transition-colors ${nodeClass[state]}`}
            aria-current={state === 'inProgress' ? 'step' : undefined}
          >
            {state === 'complete' ? <Check className="h-5 w-5" /> : i + 1}
          </span>
          {i < count - 1 && (
            <span className={`h-0.5 w-10 transition-colors sm:w-16 ${i < current ? 'bg-accent' : 'bg-border'}`} />
          )}
        </li>
      ))}
    </ol>
  )
}
